import AttachFileIcon from '@mui/icons-material/Attachment';
import SendIcon from '@mui/icons-material/Send';
import Button from 'blocks/Button';
import Card from 'blocks/Card';
import { Row, RowItem } from 'blocks/CommonLayout';
import { TextField } from 'components/Form';
import { resetFields } from 'helper/InputField';
import { getDate, getTime } from 'helper/date';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import urls from 'utils/urls';
import { ChatBoxFormModel, ChatBoxProps, MessageProps, TicketDetail } from '../../ticket.interface';
import * as S from './ticketCheckbox.styles';
const Message: React.FC<MessageProps> = ({ me = false, chat }) => {
  const { t } = useTranslation();

  return (
    <S.WrapperMessage $me={me}>
      <S.MessageRow as={Row} justify={me ? 'flex-start' : 'flex-end'}>
        <S.messageCard as={Card} $me={me}>
          {chat.type == 'file' ? (
            <>
              <S.RowAttach>
                <AttachFileIcon />
                <S.LinkFile target={'_blank'} href={`${urls.baseUrl}/api/files/${chat.content}`}>
                  {t('pages.tickets.single.info.ViewFile')}
                </S.LinkFile>
              </S.RowAttach>
              <S.messageTime as={Row} justify="flex-end">
                {getDate(chat.createdAt)} - {getTime(chat.createdAt)}
              </S.messageTime>
            </>
          ) : (
            <>
              <S.messageText>{chat.content}</S.messageText>
              <S.messageTime as={Row} justify="flex-end">
                {getDate(chat.createdAt)} - {getTime(chat.createdAt)}
              </S.messageTime>
            </>
          )}

          {me ? (
            <S.MessageCardSvgIcon>
              <svg width="8" height="20" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M6 17H0V0c.193 2.84.876 5.767 2.05 8.782.904 2.325 2.446 4.485 4.625 6.48A1 1 0 016 17z"
                    fill="#ebebeb"
                    filter="url(#a)"
                  />
                  <path
                    d="M6 17H0V0c.193 2.84.876 5.767 2.05 8.782.904 2.325 2.446 4.485 4.625 6.48A1 1 0 016 17z"
                    fill={me ? '#588AF0' : '#979fb6'}
                  />
                </g>
              </svg>
            </S.MessageCardSvgIcon>
          ) : null}
        </S.messageCard>
      </S.MessageRow>
    </S.WrapperMessage>
  );
};

const ChatBox = ({ chatList, onSend, status }: ChatBoxProps) => {
  const { t } = useTranslation();
  const { register, getValues, setValue } = useForm<ChatBoxFormModel>();
  const [defultValueFlie, setDefultValueFlie] = useState(t('pages.signup.sections.form.nofile'));

  const [loading, setLoading] = useState(false);
  const checkMineMessage = (chat: TicketDetail) => !!(!chat.adminId && chat.userId);

  const handleSend = async () => {
    setLoading(true);
    await onSend(getValues('text'), getValues('file'));
    setLoading(false);
    resetFields(['text', 'file'], setValue);
    setDefultValueFlie(t('pages.signup.sections.form.nofile'));
  };

  return (
    <S.WrapperCheckBox>
      <S.CheckBox>
        <S.CheckList>
          {chatList.map((chat) => (
            <Message key={chat.id} me={checkMineMessage(chat)} chat={chat} />
          ))}
        </S.CheckList>
        {status !== 'closed' && (
          <S.CheckInputList as={Row} align="center">
            <S.FileWrapper>
              <TextField
                dir={'ltr'}
                id="file"
                fullWidth
                type="file"
                required
                onChange={(value: any) => {
                  console.log(value.target.files);
                  setValue('file', value.target.files[0]);
                  setDefultValueFlie(getValues('file')['name']);
                }}
                nameFile={defultValueFlie}
                setNameFile={setDefultValueFlie}
              />
            </S.FileWrapper>
            <RowItem>
              <S.CheckInput as={TextField} control={register('text')} />
            </RowItem>
            <S.SendMessageButton as={Button} type="button" iconButton circular loading={loading} onClick={handleSend}>
              <SendIcon />
            </S.SendMessageButton>
          </S.CheckInputList>
        )}
      </S.CheckBox>
    </S.WrapperCheckBox>
  );
};

export default ChatBox;
